import React, { useEffect } from 'react';
import { Box } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import DetailInformation from './DetailInformation';
import DetailButtonContainer from './DetailButtonContainer';
import { defineBillImageByCountry } from '../../../../../../helpers/orders/OrdersHelper';
import { PURCHASE_ROUTE } from '../../../../../../constants/Routes';

const ProductMobileDetailView = () => {
  const location = useLocation();
  const history = useHistory();

  const { state } = location;

  useEffect(() => {
    if (!state) history.push(PURCHASE_ROUTE);
  }, []);

  return (
    <Box
      padding="0px 30px"
      marginTop="28px"
      display="flex"
      flexDirection="column"
      width="100%"
    >
      {state?.product && (
        <>
          <DetailInformation
            name={state.product.name}
            orderId={state.product.orderId}
            sku={state.product.sku}
            quantity={state.product.quantity}
            totalPrice={state.product.totalPrice}
            purchaseDate={state.product.purchaseDate}
            isMkp={state.product.isMkp}
            thumbnailImage={state.product.thumbnailImage}
            purchaseState={state.product.purchaseState}
          />
          <DetailButtonContainer
            billImage={defineBillImageByCountry(
              state.product.billImage,
              state.product.orderId,
              state.product.source,
            )}
            dispatch={state.product.dispatch}
            orderId={state.product.orderId}
            errorTracking={state.product.errorTracking}
            name={state.product.name}
            sku={state.product.sku}
            urlNc={state.product.urlNc}
          />
        </>
      )}
    </Box>
  );
};

export default ProductMobileDetailView;
